import { Component, OnInit, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TenderService } from '../../../services/tender.service';
import { LoadingState } from '../../loading/loading.component';
import { AddDesignationModalComponent } from '../add-designation-modal/add-designation-modal.component';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-resource-contact-tab',
  templateUrl: './resource-contact-tab.component.html',
  styleUrls: ['./resource-contact-tab.component.scss']
})
export class ResourceContactTabComponent implements OnInit {
  @Input() tenderId: number;
  loading: LoadingState = LoadingState.NotReady;
  tenderDesignationList: any = [];
  constructor(
    public dialog: MatDialog,
    private tenderService: TenderService
  ) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    var forkArray = [];
    var params = '';
    params = '?tender=' + this.tenderId
    forkArray.push(this.tenderService.getTenderResourceDesignationList(params))
    forkJoin(forkArray).subscribe(
      (res: any[]) => {
       // console.log(res)
        for (var i = 0; i < res.length; i++) {
          if (i == 0) {
            this.tenderDesignationList = res[i]['result'];
          }
        }
        this.loading = LoadingState.Ready
      },
      error => {
        console.log(error)
        this.loading = LoadingState.Ready
      }
    )
  }



  openDesignationModal() {
    let dialogRef = this.dialog.open(AddDesignationModalComponent, {
      width: '525px',
      data: { tenderId: this.tenderId }
    });
    dialogRef.afterClosed().subscribe(result => {
   //   console.log(result)
      if (result['data'] != undefined) {
        this.tenderDesignationList.push(result['data'])
      }
    })
  }

  editDesignation(i) {
    let designationDetailsData = Object.assign({}, this.tenderDesignationList[i]);
    let dialogRef = this.dialog.open(AddDesignationModalComponent, {
      width: '525px',
      data: { tenderId: this.tenderId, designationDetails: designationDetailsData }
    });
    dialogRef.afterClosed().subscribe(result => {
      //console.log(result)
      if (result['data'] != undefined) {
        this.tenderDesignationList[i] = result['data']
      }
    })
  }

}
